// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".storyblok-one-column{width:100%;padding:24px;flex-wrap:wrap;flex-direction:column}@media(max-width:960px){.storyblok-one-column{justify-content:center;padding:0}}.storyblok-one-column>div{display:flex}.storyblok-one-column a{color:var(--q4s-accent)!important;text-decoration:none;cursor:pointer}", ""]);
// Exports
module.exports = exports;
